import { createMomentsToBoardsRequest } from './momentsToBoards'
import { createMomentsToPlanRequest } from './momentsToPlan'

export const bulkUpdateBFFOperations = {
  momentsToBoards: createMomentsToBoardsRequest,
  momentsToPlan: createMomentsToPlanRequest,
}
